<template>
  <div v-if="items.length">
    <div v-if="!loading">
      <Title>{{ category }}</Title>

      <div class="category-items mt-8">
        <v-card
          :to="item.to"
          class="category-primary-item relative"
          flat
          v-if="item.title"
        >
          <img loading="lazy" :src="item.img + '?resize=1&w=450'" :alt="item.title" />

          <div class="caption">
            <div class="text">
              {{ item.title }}
            </div>
          </div>
        </v-card>

        <div class="category-list">
          <v-card
            v-for="({ title, to }, index) in items"
            :key="index"
            :to="to"
            flat
            class="category-list-item"
          >
            <v-icon class="primary--text"> fa fa-chevron-right </v-icon>

            <div class="text grey--text text--darken-4">
              {{ title }}
            </div>
          </v-card>
        </div>
      </div>
    </div>
    <v-sheet
      v-else
      class="d-flex justify-center align-center my-16"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-sheet>
  </div>
</template>

<script>
import Title from "@/components/widgets/Title.vue";
import { formatToURL } from "@/components/utils";

export default {
  data: () => ({
    loading: true,
    items: [],
    itemsPerPage: 5,
  }),
  props: {
    category: {
      type: String,
      required: true,
    },
  },
  computed: {
    categories() {
      return this.$rest("articles-categories").list.map(({ id, title }) => ({
        id,
        title,
        uri: formatToURL(title),
      }));
    },
    filterCategory() {
      return this.categories.filter(
        (category) => category.title === this.category
      )[0];
    },
  },
  methods: {
    get() {
      if (this.filterCategory) {
        const params = {
          itemsPerPage: this.itemsPerPage,
        };

        params.category = this.filterCategory.id;

        this.loading = true;

        this.$rest("articles")
          .get({ params })
          .then((data) => {
            this.items = data.map(({ id, title, img, category }) => ({
              title,
              img: this.files + img,
              to: `/noticias/${formatToURL(category.title)}/${formatToURL(
                `${title}-${id}`
              )}`,
            }));

            this.loading = false;

            this.item = this.items[0];
            this.items = this.items.splice(0, 4);
          });
      }
    },
  },
  watch: {
    filterCategory() {
      this.get();
    },
  },
  created() {
    this.get();
  },
  components: {
    Title,
  },
};
</script>

<style scoped>
.category-items {
  display: grid;
  grid-template-columns: 270px auto;
  gap: 20px;
}
@media screen and (max-width: 1264px) {
  .category-items {
    grid-template-columns: 1fr 1fr;
  }
}
@media screen and (max-width: 960px) {
  .category-items {
    grid-template-columns: 1fr;
  }
}
@media screen and (max-width: 600px) {
  .category-items {
    grid-template-columns: 1fr;
  }
}
.category-primary-item {
  transition: all 0.1s linear;
}
.category-primary-item img {
  object-fit: cover;
  aspect-ratio: 270 / 300;
  height: 100%;
  width: 100%;
}
.category-primary-item .caption {
  align-items: flex-end;
  background: rgb(0, 0, 0);
  background: -moz-linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#000000",endColorstr="#000000",GradientType=1);
  bottom: 0;
  color: #f7f7f7;
  display: flex;
  left: 0;
  padding: 19px 22px;
  position: absolute;
  right: 0;
  top: 0;
}
.category-primary-item .text {
  font-size: 16px;
  font-weight: 700;
}
.category-primary-item:hover {
  opacity: 0.9;
}
.category-list-item {
  align-items: flex-start;
  border-bottom: 1px solid #dceaf5;
  display: flex;
  padding-bottom: 12px;
}
.category-list-item:not(:first-child) {
  margin-top: 24px;
}
.category-list-item .v-icon {
  font-size: 15px;
  margin-top: 7px;
}
.category-list-item .text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  font-size: 14px;
  font-weight: 700;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  margin-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.1s linear;
}
.category-list-item:hover .text {
  color: var(--v-primary-darken2) !important;
}
@media screen and (max-width: 960px) {
  .category-list-item .text {
    line-clamp: initial;
    -webkit-line-clamp: initial;
  }
}
</style>
